import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { queryCommonFlags } from "@/api/constants";
import { debounce } from "lodash";
import { fetchAmenitiesLookups } from "../../api/property-management";

const useAmenitiesFilterOptions = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = useMemo(
    () =>
      debounce((value) => {
        setSearchTerm(value);
      }, 300),
    []
  );

  const {
    data: amenities,
    error: amenitiesError,
    isLoading: amenitiesLoading,
    refetch: refetchAmenities,
  } = useQuery({
    queryKey: ["amenities", searchTerm],
    queryFn: () => fetchAmenitiesLookups(searchTerm),
    ...queryCommonFlags,
    staleTime: 60000,
  });

  return {
    refetchAmenities,
    amenities: amenities?.data,
    amenitiesError,
    amenitiesLoading,
    handleSearchChange,
    searchTerm,
  };
};

export default useAmenitiesFilterOptions;
